import type { User } from 'oidc-client-ts';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';

import { APP_ID, AUTH_AUTHORITY } from '@/constants/env';
import { SESSION_STORAGE } from '@/constants/storage';

export const userManager = new UserManager({
  authority: AUTH_AUTHORITY,
  client_id: APP_ID,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  monitorSession: true,
});

export const OIDC_CONFIG: AuthProviderProps = {
  userManager,
  onSigninCallback: (_user: User | void): void => {
    // Signal to useTrackSignIn that a fresh sign-in just occurred and the backend must be notified.
    sessionStorage.setItem(SESSION_STORAGE.shouldNotifySignIn.key, 'true');
    // Remove the payload from the URL upon successful login. Otherwise if you refresh the page and the payload is still there, signinSilent - which handles renewing your token - won't work.
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export const UPDATE_PASSWORD_URL = `${AUTH_AUTHORITY}/protocol/openid-connect/auth?client_id=${APP_ID}&redirect_uri=${window.location.origin}&response_type=code&scope=openid&kc_action=UPDATE_PASSWORD`;
export const FORGOT_PASSWORD_URL = `${AUTH_AUTHORITY}/login-actions/reset-credentials?client_id=${APP_ID}&redirect_uri=${window.location.origin}&response_type=code&scope=openid`;
